export const PAGE_TITLE = 'Unit'
export const BACK_LINK_DIGITAL_WELL_BEING = 'Digital Well-Being Lessons'
export const SHUTTER_LIST_CLASS_NAME = 'unit-v3-shutter-list'
